import React from 'react';
import { common } from 'themes/default';
import CircularSpinner from './CircularSpinner';
import { propTypes, propDescriptions, defaultProps } from './Spinner.props';
import StarLoader from './StarLoader';

const Spinner = ({ size, type }) =>
  type === 'eurostar' ? (
    <StarLoader
      size={size !== defaultProps.size ? size : common.spinners.pageLoaderSize}
      dataId="Spinner"
      color={common.spinners.colour.toString()}
    />
  ) : (
    <CircularSpinner
      size={size !== defaultProps.size ? size : common.spinners.loadingButtonSize}
      dataId="Spinner"
      color={common.spinners.colour.toString()}
    />
  );

Spinner.propTypes = propTypes;
Spinner.propDescriptions = propDescriptions;
Spinner.defaultProps = defaultProps;

export default Spinner;
